// Shared helpers for attachment chips — used by the reading pane (received
// attachments) and the compose modal (outgoing attachments) so both surfaces
// look and format the same.

export function formatSize(bytes) {
  if (!bytes || bytes < 1024) return `${bytes || 0} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

// Lightweight file-type badge. Maps extension / MIME type to a short label
// and a palette colour. Matches the Microsoft 365 convention of colour-coded
// document icons without needing to ship a full icon pack.
export function fileBadge(att) {
  const name = String(att.name || '');
  const ext  = (name.split('.').pop() || '').toLowerCase();
  const ct   = String(att.contentType || '').toLowerCase();
  const map = {
    pdf:  { label: 'PDF', bg: '#fbe4e4', fg: '#b42318' },
    doc:  { label: 'DOC', bg: '#e1ecff', fg: '#1b4fb0' },
    docx: { label: 'DOC', bg: '#e1ecff', fg: '#1b4fb0' },
    xls:  { label: 'XLS', bg: '#e1f4e6', fg: '#0b6b2e' },
    xlsx: { label: 'XLS', bg: '#e1f4e6', fg: '#0b6b2e' },
    csv:  { label: 'CSV', bg: '#e1f4e6', fg: '#0b6b2e' },
    ppt:  { label: 'PPT', bg: '#fde3d3', fg: '#b04b11' },
    pptx: { label: 'PPT', bg: '#fde3d3', fg: '#b04b11' },
    zip:  { label: 'ZIP', bg: '#eee1fb', fg: '#5a2dc1' },
    rar:  { label: 'ZIP', bg: '#eee1fb', fg: '#5a2dc1' },
    png:  { label: 'IMG', bg: '#dff5f9', fg: '#0a7490' },
    jpg:  { label: 'IMG', bg: '#dff5f9', fg: '#0a7490' },
    jpeg: { label: 'IMG', bg: '#dff5f9', fg: '#0a7490' },
    gif:  { label: 'IMG', bg: '#dff5f9', fg: '#0a7490' },
    webp: { label: 'IMG', bg: '#dff5f9', fg: '#0a7490' },
    svg:  { label: 'SVG', bg: '#dff5f9', fg: '#0a7490' },
    txt:  { label: 'TXT', bg: '#eceaf0', fg: '#3f3d47' },
    eml:  { label: 'EML', bg: '#e4e7ee', fg: '#0f1a33' },
    msg:  { label: 'MSG', bg: '#dff5f9', fg: '#0a7490' },
    html: { label: 'HTML', bg: '#fce7f3', fg: '#9d174d' },
    htm:  { label: 'HTM', bg: '#fce7f3', fg: '#9d174d' },
    json: { label: 'JSON', bg: '#fef3c7', fg: '#92400e' },
    xml:  { label: 'XML', bg: '#fef3c7', fg: '#92400e' },
    ai:   { label: 'AI',  bg: '#fde3d3', fg: '#b04b11' },
    eps:  { label: 'EPS', bg: '#fde3d3', fg: '#b04b11' },
  };
  if (map[ext]) return map[ext];
  if (ct.startsWith('image/')) return { label: 'IMG', bg: '#dff5f9', fg: '#0a7490' };
  if (ct.startsWith('text/'))  return { label: 'TXT', bg: '#eceaf0', fg: '#3f3d47' };
  if (ct.includes('pdf'))      return { label: 'PDF', bg: '#fbe4e4', fg: '#b42318' };
  return { label: (ext || 'FILE').toUpperCase().slice(0, 4), bg: '#eceaf0', fg: '#3f3d47' };
}
